<template>
  <b-container fluid class="">
    <h1 class="m-3">
      {{ title }}
    </h1>
    <commonActions ref="commonAction" :data-ready="dataReadyTables" :filename-prefix="title"
      @commonFiltersUpdated="commonFiltersUpdated($event)" @clickDownloadPdf="downloadPdf($event)"
      @clickDownloadExcel="downloadExcel($event)" />
    <table-renderer v-for="data of tablesData" :key="data.tableNumber" :table-number="data.tableNumber"
      ref="tableRenderers" :data-table="data.dataTable" :dimension-fields="dimensionColumnsTables"
      :measure-fields="measureColumnsTables" :table-header="data.tableHeader" :group-headers="groupHeaders"
      :default-sorted-column="defaultSortedColumnTables" :totals-data="data.totalsData" :data-ready="dataReadyTables"
      :hide-groups="hideGroupsByTableNumber[data.tableNumber] === true" :custom-table-class="customTableClass"
      @sort-changed="sortChanged" />
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import Tools from "@/utils/tools";
import TableTools from "@/utils/tableTools";
import paths from "@/router/pathConstants";
import TableRenderer from "@/components/TableRenderer.vue";
import commonActions from "@/components/pages/commonActions";
import dimensionEnum from "@/model/dimensionEnum";
import { calculatedColumnsEnum } from "@/model/columnsEnums";
import { dateFormatEnum } from "@/filter/dateFormat";
import moment from "moment";
import { GamesCode } from "@/router/routeNames";

export default {
  name: GamesCode,
  components: {
    TableRenderer,
    commonActions,
  },
  data() {
    return {
      /** Tableau de filtres tels qu'attendu par cubeJs.
       * Ex :
       *    [
       *      {
       *        dimension: "Site.Id",
       *        operator: "equals",
       *        values: ["85007419-23D3-48AB-89E7-68089F46FA7D"]
       *      },
       *      {
       *        dimension: "BusinessDate.id",
       *        operator: "inDateRange",
       *        values: ["2020-09-23", "2020-09-26"]
       *      },
       */
      commonFilters: [],
    };
  },
  computed: {
    ...mapState({
      dimensionColumnsTables: (state) => state.games.dimensionColumnsTables,
      measureColumnsTables: (state) => state.games.measureColumnsTables,
      groupHeaders: (state) => state.games.groupHeaders,
      defaultSortedColumnTables: (state) =>
        state.games.defaultSortedColumnTables,
      tablesData: (state) => state.games.tablesData,
      hideGroupsByTableNumber: (state) => state.games.hideCustomGroupsByTableNumber,
      dataReadyTables: (state) => state.games.dataReadyTables,
    }),
    title() {
      return this.$t("title.games_code");
    },
    customTableClass() {
      return "table-width-xl";
    },
  },
  async mounted() {
    this.$store.dispatch("games/initDisplayTables", {
      defaultSortedColumnTables: calculatedColumnsEnum.RANK,
    });
    if (this.$route.query.siteId) {
      Tools.StorageHelper.storeFilterSelectedValue("Site.id", [
        this.$route.query.siteId.toUpperCase(),
      ]);
    }
    if (this.$route.query.warmDataBase == "true") {
      const siteIds = await this.getSites();
      Tools.StorageHelper.storeFilterSelectedValue("Site.id", siteIds);
      let startDateWarmup = new Date().setFullYear(
        new Date().getFullYear() - 1,
        new Date().getMonth(),
        new Date().getDate()
      );
      Tools.StorageHelper.storeDateRangeSelectedValues(
        "DateRangePicker",
        [
          moment(startDateWarmup).format(dateFormatEnum.SQL_DATE_FORMAT),
          moment(new Date()).format(dateFormatEnum.SQL_DATE_FORMAT),
        ],
        dateFormatEnum.SQL_DATE_FORMAT
      );
    }
  },
  methods: {
    async getSites() {
      const query = {
        dimensions: [dimensionEnum.SITE],
        filters: [],
      };
      const resultSet = await TableTools.Helper.doRequest(query);
      return resultSet.map((o) => {
        return o[dimensionEnum.SITE].toUpperCase();
      });
    },
    async commonFiltersUpdated(value) {
      try {
        this.$store.dispatch("games/resetDataReadyTables");
        this.commonFilters = value.filters;
        await this.$store.dispatch("games/updateTableList", {
          filters: this.commonFilters,
          timeDimension: value.timeDimension || null,
          siteValues: value.siteValues,
          withCategoriesRows: true,
          isDefaultDisplayCategoriesRows: true,
          groupColumnsTables: dimensionEnum.GAME_CODE,
          displayTaxePercent: true,
          isGroupedByCode: true
        });
      } catch (error) {
        Tools.Alerts.Error(this.$swal, error);
      }
    },
    sortChanged(e) {
      this.$store.dispatch("games/updateHideGroupsByTableNumber", {
        tableNumber: e.tableNumber,
        value: false,
      });
      this.$store.dispatch("games/updateHideCustomGroupsByTableNumber", {
        tableNumber: e.tableNumber,
        value: e.event.sortBy !== dimensionEnum.GAMECATEGORY_NAME,
      });
    },
    downloadPdf(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_PDF, "_blank");
      }
    },
    downloadExcel(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_EXCEL, "_blank");
      }
    },
    storeExportData(filename, subtitles) {
      const self = this;
      var datasForExport = [];

      self.tablesData.forEach((table, index) => {

        const renderer = self.$refs.tableRenderers?.[index];
        const sortKey = renderer?.sortedColumn || self.defaultSortedColumnTables;

        const hideGroups = self.hideGroupsByTableNumber[table.tableNumber] === true;
        const dataTableForExport = hideGroups
          ? table.dataTable.filter((row) => row.groupLevel === undefined)
          : table.dataTable;

        const data = TableTools.Helper.assembleExportDataTable(
          dataTableForExport,
          self.dimensionColumnsTables,
          self.measureColumnsTables,
          self.groupHeaders,
          table.tableHeader,
          sortKey,
          null,
          table.totalsData,
          table.tableNumber,
          self.customTableClass
        );
        datasForExport.push(data);
      });

      TableTools.Helper.storeExportData(
        datasForExport,
        self.title,
        subtitles,
        filename,
        {}
      );
    },
  },
};
</script>
